import type { AgentRunEventSummary } from "../ui-types.ts";

const MAX_EVENTS_PER_RUN = 50;

function labelForToolEvent(name: string, phase: string): string {
  if (phase === "start") return `Calling ${name}`;
  if (phase === "update") return `Updating ${name}`;
  if (phase === "result") return `${name} result`;
  return name;
}

function labelForLifecycle(phase: string): string {
  switch (phase) {
    case "start":
      return "Agent started";
    case "end":
      return "Agent finished";
    case "error":
      return "Agent error";
    case "thinking":
      return "Thinking";
    case "compacting":
      return "Compacting context";
    default:
      return phase;
  }
}

function labelForStream(): string {
  return "Generating";
}

export function summarizeAgentEvent(
  existing: AgentRunEventSummary[],
  _runId: string,
  seq: number,
  ts: number,
  stream: string,
  data: Record<string, unknown>,
): AgentRunEventSummary[] {
  let label: string;
  let phase: string | undefined;
  let name: string | undefined;
  let detail: string | undefined;
  let isError = false;

  if (stream === "tool") {
    name = typeof data.name === "string" ? data.name : undefined;
    phase = typeof data.phase === "string" ? data.phase : undefined;
    label = name ? labelForToolEvent(name, phase ?? "") : "Tool";
    if (phase === "result" && !isError) {
      const resultText =
        typeof data.result === "string"
          ? data.result
          : typeof data.partialResult === "string"
            ? data.partialResult
            : undefined;
      if (resultText) {
        detail = resultText.slice(0, 200);
      }
    }
  } else if (stream === "lifecycle") {
    phase = typeof data.phase === "string" ? data.phase : undefined;
    label = labelForLifecycle(phase ?? "");
    if (phase === "error") {
      isError = true;
      detail = typeof data.error === "string" ? data.error.slice(0, 300) : undefined;
    }
  } else if (stream === "assistant") {
    label = labelForStream();
  } else {
    label = stream;
  }

  const entry: AgentRunEventSummary = {
    seq,
    ts,
    stream,
    label,
    phase,
    name,
    detail,
    isError,
  };

  const filtered = existing.filter(
    (e) => !(e.stream === "tool" && e.name === name && e.seq < seq && e.phase !== "result"),
  );

  const next = [...filtered, entry];
  if (next.length > MAX_EVENTS_PER_RUN) {
    return next.slice(next.length - MAX_EVENTS_PER_RUN);
  }
  return next;
}
